import React, { useEffect, useState } from "react";
import FilerobotImageEditor, { TABS, TOOLS } from "react-filerobot-image-editor";
import "./editor.css";
import { MessageAPIService } from "../../services/api";
import bundle from "../../assests/Images/bundle.png";
import { Box } from "@mui/system";

const ImageEditor = ({ imageUrl, imageId, onClose,onSave }) => {

const fileName = imageUrl.split("/").pop();
const [loading, setLoading] = useState(false);


  useEffect(() => {
    const updateModalTitle = () => {
      const modalTitle = document.querySelector(".SfxModalTitle-LabelPrimary");
      if (modalTitle) {
        modalTitle.textContent = "Once it is saved, it can't be undone.";
        return true;
      }
      return false;
    };

    // Try once immediately in case it's already in DOM
    if (updateModalTitle()) return;

    // Set up MutationObserver
    const observer = new MutationObserver(() => {
      if (updateModalTitle()) {
        observer.disconnect(); // stop observing once found
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Cleanup on unmount
    return () => observer.disconnect();
  });

  const handleBase64 = async (base64)=>{
    setLoading(true);
    try {
      const payload = {
        From: "",
        Body: "",
        NumMedia: 1,
        MediaUrl0: base64,
        fileName
      };

      const getImageUrl = await MessageAPIService.getImageURL(payload);

      if (getImageUrl) {
        setLoading(false);
        onSave(getImageUrl?.saved_files?.[0]); // Notify parent with new image URL

      }

    } catch (error) {
      setLoading(false);
      console.log(" error", error);
    }
  }

  return (
    <>
    {loading ?
      <>
      <Box sx={{margin:"auto"}}>
      <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
        {/* <CircularProgress /> */}
        <img src={bundle} width="60px"/>
      </Box>
      <Box display="flex" justifyContent="center" alignItems="center"  textAlign="center" mt={2}>
        Your changes are being saved, please wait a moment!
        </Box>
        </Box>
        </>
   :
    <FilerobotImageEditor
      source={imageUrl}
      onSave={(editedImageObject, designState) => {
        handleBase64(editedImageObject?.imageBase64)
        // if (onSave) {
        //     onSave(editedImageObject, imageId);
        //   }
      }}
      onClose={onClose}
      annotationsCommon={{ fill: "#ff0000" }}

      Rotate={{ angle: 90, componentType: "slider" }}
      Crop={{
        presetsItems: [
          {
            titleKey: "Recommended ratio",
            width: 300,
            height: 250,
            descriptionKey: "",
          }
        ],
        defaultPresetItemsIndex: 0
      }}
      tabsIds={[TABS.ADJUST, TABS.FILTERS, TABS.FINETUNE]}
      defaultTabId={TABS.CROP}
      defaultToolId={TOOLS.CROP}
    />
    }
</>
  );
};


export default ImageEditor;
